import React from "react";
import { 
  Grid, Typography, Autocomplete, TextField, Checkbox, 
  TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper
} from "@mui/material";
import { medicationOptions, commonRemarks, specialItems } from "../constants/options";

const SpecialChecklistSection = ({ formData, handleAutocompleteChange, handleCheckboxChange }) => {
  const items = specialItems[0];

  return (
    <>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Autocomplete
            freeSolo
            options={medicationOptions || []}
            inputValue={formData.medication_details || ''}
            onInputChange={(event, newInputValue) => handleAutocompleteChange("medication_details", newInputValue)}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Medication details"
                variant="outlined"
                fullWidth
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="h6">Blood units</Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Autocomplete
            freeSolo
            options={["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"]}
            inputValue={String(formData.blood_units || '')}
            onInputChange={(event, newInputValue) => handleAutocompleteChange("blood_units", newInputValue)}
            renderInput={(params) => (
              <TextField {...params} label="No Of Blood Units" fullWidth />
            )}
          />
        </Grid>
        
        <Grid item xs={12} sm={6}>
          <Typography variant="h6">Vital Signs / CBG</Typography>
        </Grid>
        <Grid item xs={12} sm={1}>
          PR
          <Checkbox
            checked={formData.vital_pr === "Yes"}
            onChange={() => handleCheckboxChange("vital_pr", formData.vital_pr === "Yes" ? "No" : "Yes")}
          />
        </Grid>
        <Grid item xs={12} sm={1}>
          BP
          <Checkbox
            checked={formData.vital_bp === "Yes"}
            onChange={() => handleCheckboxChange("vital_bp", formData.vital_bp === "Yes" ? "No" : "Yes")}
          />
        </Grid>
        <Grid item xs={12} sm={1}>
          O2Sat
          <Checkbox
            checked={formData.vital_o2sat === "Yes"}
            onChange={() => handleCheckboxChange("vital_o2sat", formData.vital_o2sat === "Yes" ? "No" : "Yes")}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Autocomplete
            freeSolo
            options={commonRemarks || []}
            inputValue={formData.vital_pr_remarks || ""}
            onInputChange={(event, newInputValue) => handleAutocompleteChange("vital_pr_remarks", newInputValue)}
            renderInput={(params) => (
              <TextField {...params} label="Remarks" fullWidth />
            )}
          />
        </Grid>
      </Grid>

      <TableContainer
        component={Paper}
        sx={{
          mt: 4,
          overflowX: 'auto',
          maxWidth: '100vw',
          '& table': {
            tableLayout: 'fixed',
            width: '100%',
            minWidth: 850,
          },
        }}
      >
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell sx={{ width: 30, whiteSpace: 'nowrap' }}>No</TableCell>
              <TableCell sx={{ width: 300, whiteSpace: 'normal' }}>Special Informations</TableCell>
              <TableCell sx={{ width: 50 }}>Yes</TableCell>
              <TableCell sx={{ width: 50 }}>No</TableCell>
              <TableCell sx={{ width: 100, whiteSpace: 'normal' }}>Remarks</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.key.map((item, index) => (
              <TableRow key={index}>
                <TableCell sx={{ whiteSpace: 'nowrap' }}>{index + 1}</TableCell>
                <TableCell sx={{ whiteSpace: 'normal' }}>{items.name[index]}</TableCell>
                <TableCell>
                  <Checkbox
                    checked={formData[item] === "Yes"}
                    onChange={() => handleCheckboxChange(item, "Yes")}
                  />
                </TableCell>
                <TableCell>
                  <Checkbox
                    checked={formData[item] === "No"}
                    onChange={() => handleCheckboxChange(item, "No")}
                  />
                </TableCell>
                <TableCell sx={{ width: 400, padding: 0 }}>
                  <Autocomplete
                    freeSolo
                    options={commonRemarks || []}
                    value={formData[`${item}_remarks`] || ""}
                    onChange={(event, newValue) => handleAutocompleteChange(`${item}_remarks`, newValue || "")}
                    onInputChange={(event, newInputValue) => handleAutocompleteChange(`${item}_remarks`, newInputValue)}
                    sx={{ width: '100%' }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        multiline
                        minRows={2}
                        placeholder="Remarks"
                        variant="outlined"
                        size="small"
                        sx={{ width: '100%', boxSizing: 'border-box', padding: '8px' }}
                      />
                    )}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default SpecialChecklistSection;
